import React from 'react'
import clsx from 'clsx'

export interface LoadingSpinnerProps {
  className?: string
  size?: 'sm' | 'md' | 'lg' | 'xl'
  text?: string
  showText?: boolean
  color?: 'white' | 'teal' | 'gray' | 'blue'
}

const sizes = {
  sm: 'h-4 w-4',
  md: 'h-5 w-5',
  lg: 'h-6 w-6',
  xl: 'h-8 w-8',
}

const colors = {
  white: 'text-white',
  teal: 'text-primary',
  gray: 'text-gray-500',
  blue: 'text-blue-500',
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ className = '', size = 'md', text = 'Loading...', showText = true, color = 'white' }) => {
  return (
    <div className={clsx('flex items-center justify-center', className)}>
      <svg className={clsx('animate-spin -ml-1 mr-3', sizes[size], colors[color])} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" data-testid="loading-spinner">
        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
      </svg>
      {showText && <span>{text}</span>}
    </div>
  )
}

LoadingSpinner.displayName = 'LoadingSpinner'

export default LoadingSpinner
